import { defineComponent as a, createElementBlock as t, openBlock as o, normalizeClass as l, createCommentVNode as p, renderSlot as r, createTextVNode as n } from "vue";
const d = {
  key: 0,
  class: "property-detail-prefix"
}, i = {
  key: 1,
  class: "property-detail-value"
}, u = {
  key: 2,
  class: "property-detail-value"
}, m = /* @__PURE__ */ a({
  __name: "SchemaPropertyDetail",
  props: {
    truncate: { type: Boolean },
    code: { type: Boolean }
  },
  setup(c) {
    return (e, s) => (o(), t("span", {
      class: l(["property-detail", { "property-detail-truncate": e.truncate }])
    }, [
      e.$slots.prefix ? (o(), t("div", d, [
        r(e.$slots, "prefix", {}, void 0, !0),
        s[0] || (s[0] = n("  "))
      ])) : p("", !0),
      e.code ? (o(), t("code", i, [
        r(e.$slots, "default", {}, void 0, !0)
      ])) : (o(), t("span", u, [
        r(e.$slots, "default", {}, void 0, !0)
      ]))
    ], 2));
  }
});
export {
  m as default
};
